<template>
  <div class="container">
    <form
      @submit.prevent
      class="createNewProjectForm needs-validation"
      autocomplete="off"
      novalidate>
      <div class="d-flex justify-content-between">
        <h1>Create New Project</h1>
      </div>
      <div v-if="serverError" class="alert alert-danger" role="alert">
        {{serverError}}
      </div>
      <div class="card mb-2">
        <div class="card-header bg-primary text-white">
          Project Details
        </div>
        <div class="card-body">
        <LoadingSpinner v-if="submitting" message ='Saving Project' size = '1x'>
        </LoadingSpinner>
          <template v-if="!submitting">
            <div class="form-group row">
              <label for="projectName" class="col-lg-2 col-form-label label-text">
                <span class="text-danger">*</span>Project Name
              </label>
              <div class="col-lg-6">
                <input v-validate="'required'" data-vv-as="Project Name" type="text"
                  class="form-control" name="projectName" v-model="project.name"
                  placeholder="Enter Project Name" maxlength="50" />
                <small v-if="!errors.first('projectName')" class="form-text text-muted">
                  Max 50 characters
                </small>
                <div class="invalid-feedback">{{ errors.first('projectName') }}</div>
              </div>
            </div>
            <div class="form-group row">
              <label for="projectDescription" class="col-lg-2 col-form-label label-text">
                Project Description
              </label>
              <div class="col-lg-6">
                <textarea data-vv-as="Project Description"
                          type="textarea"
                          class="form-control"
                          name="projectDescription"
                          v-validate="'min:2|max:1000'"
                          v-model="project.description"
                          placeholder="Enter Project Description"
                          rows="2"
                          maxlength="1000" />
                    <small v-if="!errors.first('projectDescription')" class="form-text text-muted">
                      Minimum 2 characters. Max 1000 characters
                    </small>
                    <div class="invalid-feedback">{{ errors.first('projectDescription') }}</div>
              </div>
            </div>
          </template>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-6">
          <InstrumentForm
            :propertyInstrument="project.properties[0].propertyInstruments[0]"
            :contactError="contactError"
            @set-instrument-contact="updateContact">
          </InstrumentForm>
        </div>
        <div class="col-lg-6">
          <PropertyForm :property="project.properties[0]"></PropertyForm>
        </div>
      </div>
      <div class="d-flex justify-content-end" >
        <b-button :disabled="submitting" variant="danger" class="button-row-spacing"
          v-b-modal="'cancelConfirmation'">
          Cancel
        </b-button>
        <b-button :disabled="submitting" @click="submitWrapper()">Save Project</b-button>
      </div>
    </form>
    <CancelModal :modalId="'cancelConfirmation'" @cancelled="cancelConfirmed"></CancelModal>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import FormSubmit from '@/mixins/FormSubmit';
import RouterCheck from '@/mixins/RouterCheck';
import CancelModal from '../components/CancelModal.vue';
import InstrumentForm from '../components/InstrumentForm.vue';
import PropertyForm from '../components/PropertyForm.vue';
import { EntityModules } from '@/store/moduleConfig';
import LoadingSpinner from '../components/LoadingSpinner.vue';

export default {
  name: 'NewProject',
  components: {
    PropertyForm,
    InstrumentForm,
    CancelModal,
    LoadingSpinner,
  },
  mixins: [FormSubmit, RouterCheck],
  computed: {
    ...mapState(EntityModules.PROJECT.namespace, {
      submitting: state => state.submitting,
    }),
  },
  created() {
    this.$store.dispatch('Common/startEditMode', 'Project');
    // start from a clean slate on the currentProject
    this.$store.dispatch('CurrentProject/clearCurrentProject');
  },
  data() {
    return {
      project: {
        name: '',
        properties: [{
          name: '',
          propertyLocalities: [
            {
              localityId: '',
              primary: true,
            },
          ],
          propertyInstruments: [
            {
              instrument: {
                agreementTypeId: '',
                contacts: [
                  {},
                ],
              },
              propertyAcres: 0,
            }],
        }],
      },
      serverError: null,
      loading: false,
      contactError: false,
    };
  },
  methods: {
    submitWrapper() {
      this.checkContactError();
      this.onSubmit(
        this.project,
        EntityModules.PROJECT.namespace,
        [this.contactError],

      );
    },
    callCloseForm(entity) {
      this.$store.dispatch('Common/stopEditMode', 'Project');
      this.$router.push({ name: 'project', params: { project_id: entity.id } });
    },
    checkContactError() {
      this.contactError = !this
        .project
        .properties[0]
        .propertyInstruments[0]
        .instrument
        .contacts[0]
        .crmId;
    },
    cancelConfirmed() {
      this.$store.dispatch('Common/stopEditMode', 'Project');
      this.$router.push({
        name: 'home',
      });
    },
    updateContact(contact) {
      this.project.properties[0].propertyInstruments[0].instrument.contacts = [contact];
      this.checkContactError();
    },
  },
};
</script>
